/** @jsx jsx */
import ProductPage from '@bottlebooks/gatsby-theme-event/src/components/EventProductPage/EventProductPage';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import deepMerge from 'lodash/merge';

export default function ProductTemplate({
  data,
  pageContext,
  location,
  navigate,
}) {
  const {
    event,
    product,
    producer,
    exhibitor,
    otherProducts,
    next,
    previous,
    siteTitle,
  } = afterQuery(data);
  return (
    <ProductPage
      {...pageContext}
      event={event}
      product={product}
      exhibitor={exhibitor}
      otherProducts={otherProducts}
      otherProductsName={producer?.name}
      previous={previous}
      next={next}
      siteTitle={siteTitle}
      location={location}
      navigate={navigate}
    />
  );
}

export const pageQuery = graphql`
  query california_ProductTemplate(
    $id: String!
    $productId: ID!
    $eventId: ID!
    $exhibitorId: ID!
    $locale: Bottlebooks_ContentLocale
    $previousId: String
    $nextId: String
  ) {
    bottlebooks {
      event(eventId: $eventId, locale: $locale) {
        eventId
        # Get the IDs and other data out of registeredProducts.
        registeredProducts(
          filter: {
            productId: { eq: $productId }
            partnerId: { eq: $exhibitorId }
          }
        ) {
          nodes {
            ...EventProductPage_RegisteredProduct
            producer {
              # TODO Add filter to exclude the current product.
              products {
                nodes {
                  productId
                  product {
                    shortName
                    bottleImage {
                      publicId
                    }
                    bottleVariants {
                      bottleNetWeight
                    }
                  }
                }
              }
            }
            productSessions: customFieldValue(key: "productSessions") {
              ...FieldValue
            }
            targetCustomer: customFieldValue(
              key: "whatAreTastingAreYouRegisteringThisProdcutFor"
            ) {
              ... on Bottlebooks_SelectFieldValue {
                key
              }
            }
            targetCustomer2: customFieldValue(
              key: "whatAreYouRegisteringThisProductFor"
            ) {
              ... on Bottlebooks_MultiSelectFieldValue {
                values {
                  key
                }
              }
            }
            hasFreeShipping: customFieldValue(key: "freeShipping") {
              ...FieldValue
            }
            registration {
              ... on Bottlebooks_SingleRegistration {
                sessions: customFieldValue(key: "sessions") {
                  ...FieldValue
                }
              }
            }
          }
        }
        registrations(filter: { companyId: { eq: $exhibitorId } }) {
          nodes {
            # This is a quick fix to get the data onto the page
            ...bb_Registration
            exhibitorId: companyId
          }
        }
        product(
          productId: $productId
          exhibitorId: $exhibitorId
          returnNullWhenNotFound: true
        ) {
          ...bb_EventProductPage
          ... on Bottlebooks_Wine {
            wineType(format: LOCALIZED)
          }
        }
      }
    }
    product(id: { eq: $id }) {
      id
      productId
      ...EventProductPage
      producer {
        name
        products {
          ...EventProductPage_Related
        }
      }
    }
    previous: product(id: { eq: $previousId }) {
      ...ChangeProductLink
    }
    next: product(id: { eq: $nextId }) {
      ...ChangeProductLink
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;

export function afterQuery({ bottlebooks, product, previous, next, site }) {
  const event = bottlebooks?.event;
  // Pick out the registeredProduct data, so we can mix it into the base product.
  const registeredProduct = bottlebooks?.event?.registeredProducts?.nodes?.[0];
  const exhibitor = bottlebooks?.event?.registrations?.nodes?.[0];
  const extendedProduct = deepMerge(
    {},
    { ...product, exhibitor: { ...product?.exhibitor, ...exhibitor } },
    bottlebooks?.event?.product,
    registeredProduct?.product,
    registeredProduct,
    {
      sessions: [],
      isTradeOnly:
        registeredProduct?.targetCustomer?.key === 'tradeOnlyUpTo2Wines' ||
        registeredProduct?.targetCustomer2?.values?.[0]?.key === 'tradeOnly',
      hasFreeShipping: registeredProduct?.hasFreeShipping?.value,
      // registeredProduct?.productSessions?.values?.length > 0
      //   ? registeredProduct?.productSessions?.values
      //   : registeredProduct?.registration?.sessions?.values?.length > 0
      //   ? registeredProduct?.registration?.sessions?.values
      //   : [],
    }
  );
  const producerProducts = registeredProduct.producer?.products?.nodes || [];
  const otherProducts = producerProducts
    .filter((other) => other.productId !== product.productId)
    .slice(0, 6);

  return {
    product: extendedProduct,
    producer: extendedProduct?.producer,
    exhibitor,
    event,
    siteTitle: site.siteMetadata.title,
    next,
    previous,
    otherProducts,
  };
}
